import { IUploadedFileDto } from "../common/model/file-exchange-dto";

export const  FileExchangeToFile = async (exchange: IUploadedFileDto): Promise<File> => {
    const byteString = atob(exchange.content);
    const bytes = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
        bytes[i] = byteString.charCodeAt(i);
    }

    return new File([bytes], exchange.filename, { type: exchange.mimeType });
};
